import React from "react";
import {
  ENDPOINTS,
  countyAddRows,
  countyHeader,
  countySearchKeys,
  countyUpdateRows,
} from "../../helpers/constants";
import AppChoiceEntityCRUD from "../AppChoiceEntityCRUD";

const Counties = ({ appChoices }) => {
  return (
    <AppChoiceEntityCRUD
      primaryKey="county"
      entityAppChoiceKey="County"
      entityName="Counties"
      entityTableHeaders={countyHeader}
      entityTableSearchKeys={countySearchKeys}
      addFormRows={countyAddRows}
      appChoices={appChoices}
      updateFormRows={() =>
        typeof userUpdateRows === "function"
          ? countyUpdateRows()
          : countyUpdateRows
      }
      request={{
        endPoint: (id) => ENDPOINTS.APP_CHOICES_WITH_ID(id),
        method: "PUT",
      }}
    />
  );
};

export default Counties;
